var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d626c",
    d: "M0 36V4.5h1.477V36zm2.2-.022V4.5h.75v31.478zm2.227 0V4.5h.727v31.478zm3.68 0V4.5h.727v31.478zm2.953 0V4.5h1.453v31.478zm3.68 0V4.5h.727v31.478zm1.477 0V4.5h.727v31.478zm1.477 0V4.5h.727v31.478zm2.93 0V4.5H22.1v31.478zm3.68 0V4.5h1.477v31.478zm2.953 0V4.5h1.477v31.478zm2.953 0V4.5h1.477v31.478zm2.2 0V4.5h1.477v31.478zm3.7 0V4.5h2.2v31.478zm2.93 0V4.5h.75v31.478zm1.483.022V4.5H42V36z",
    transform: "translate(0 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.e6e87de03030abe77a71736dd577aae9.svg";
export { ForwardRef as ReactComponent };